<template>
    <div class="sendshare">
        {{this.discussion}}
    </div>
</template>

<script>
export default {
    name:'sendshare',
    data() {
        return {
           discussion:'发布共享'
        }
    },
}
</script>

<style lang="less" scoped>
   .sendshare{
       width: 100%;
   }
</style>


// WEBPACK FOOTER //
// src/components/user/usercolumn/release/sendshare.vue